import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { PharmacieDto } from '../DTO/pharmacie.dto';
import { ContactSupportDto } from '../DTO/contact-support.dto';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private CLIENT_ENDPOINT = environment.CLIENT_API_ENDPOINT + '/';

  constructor(private httpClient: HttpClient) {
  }

  isExistingCode(code: string) {
    return this.httpClient.get(this.CLIENT_ENDPOINT +'existing-code?code=' + code);
  }

  postMailConfirm(code: string) {
    return this.httpClient.post(this.CLIENT_ENDPOINT +'mail-confirm', JSON.stringify({code: code}));
  }

  postReinitPassword(code: string, password: string) {
    return this.httpClient.post(this.CLIENT_ENDPOINT +'reinit-password', JSON.stringify({code: code, password: password}));
  }

  sendSMSToClient(message: string) {
    return this.httpClient.post(environment.API_ENDPOINT + '/' +'sendSMSClient', JSON.stringify({"message": message}));
  }

}
